import React, { PropsWithChildren, useRef } from "react";

import "./modal.css";
import { useKeyDown, useKeyTrap } from "../../hooks/useKeyboard";
import { useFocusLock } from "../../hooks/useFocusLock";

export const Modal = ({
	isOpen,
	children,
	onScrimClick,
}: PropsWithChildren<{
	isOpen: boolean;
	onScrimClick?: () => void;
}>) => {
	const ref = useRef<HTMLDivElement>(null);

	useFocusLock(ref, {
		isActive: isOpen,
	});

	useKeyDown(
		(event) => {
			if (event.key === "Escape") {
				onScrimClick?.();
				event.stopPropagation();
			}
		},
		{
			enabled: isOpen && !!onScrimClick, // Only allow Escape key if user also can close it by clicking next to the modal
			ref, // No need to trap keys on the modal itself, just on the scrim
			enableOnFormTags: true, // Usecase: Example Save dialog where text input is focused, save to do?
		},
	);

	// Prevent keystrokes bubble up to the parent elements
	useKeyTrap(isOpen ? ref : null);

	if (!isOpen) return null;

	return (
		<>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions*/}
			<div
				className="modal__scrim"
				onClick={(event) => {
					onScrimClick?.();
					event.stopPropagation();
				}}
			/>
			<div ref={ref} tabIndex={-1}>
				{children}
			</div>
		</>
	);
};

Modal.displayName = "Modal";
